import { createAction } from 'redux-actions';

export const COURSEINFO_SET_COURSE_DATA = 'COURSE_INFO/SET_COURSE_DATA';
export const COURSEINFO_RESET_COURSE_DATA = 'COURSE_INFO/RESET_COURSE_DATA';
export const COURSEINFO_SET_COURSEOUTLINE_DATA = 'COURSE_INFO/SET_COURSEOUTLINE_DATA';
export const COURSEINFO_RESET_COURSEOUTLINE_DATA = 'COURSE_INFO/RESET_COURSEOUTLINE_DATA';
export const COURSEINFO_SET_COURSEITEM_DATA = 'COURSE_INFO/SET_COURSEITEM_DATA';
export const COURSEINFO_RESET_COURSEITEM_DATA = 'COURSE_INFO/RESET_COURSEITEM_DATA';

export const setCourseData = createAction(
  COURSEINFO_SET_COURSE_DATA,
  (courseId, courseReferId, title, classroomId) => ({ courseId, courseReferId, title, classroomId })
);
export const setCourseOutlineData = createAction(
  COURSEINFO_SET_COURSEOUTLINE_DATA,
  (courseOutline = []) => ({ courseOutline })
);
export const setCourseItemData = createAction(
  COURSEINFO_SET_COURSEITEM_DATA,
  (
    sectionId,
    sectionReferId,
    sectionTitle,
    subsectionId,
    subsectionReferId,
    subsectionTitle,
    resuming = false
  ) => ({
    sectionId,
    sectionReferId,
    sectionTitle,
    subsectionId,
    subsectionReferId,
    subsectionTitle,
    resuming,
  })
);

export const clearCourseData = createAction(COURSEINFO_RESET_COURSE_DATA);
export const clearCourseOutlineData = createAction(COURSEINFO_RESET_COURSEOUTLINE_DATA);
export const clearCourseItemData = createAction(COURSEINFO_RESET_COURSEITEM_DATA);
